declare var SimpleBar;
declare var makeVideoPlayerHtml;
declare var videojs;
declare var liveDemoLang;

namespace AgerLMS.WebSite {

    export interface AfterGraduationPageWidgetRequest {
        ItemId: number;
        ItemName: string;
    }

    @Serenity.Decorators.registerClass()
    export class AfterGraduationPageWidget extends Serenity.Widget<AfterGraduationPageWidgetRequest> {

        widgetKey: string = "JoinAfterGraduation";
        widgetKey_: string = this.widgetKey + "_";
        idWidgetKey: string = "#" + this.widgetKey;
        idWidgetKey_: string = this.idWidgetKey + "_";
        modalStr : string = this.idWidgetKey + "Modal";
        modal: JQuery = $(this.modalStr);
        button: string = this.idWidgetKey + "Button";
        formSelector: string = this.idWidgetKey + "Form";

        openModalId : string = "#Open" + this.widgetKey + "Modal";

        cityId : JQuery = $(this.idWidgetKey_+ "CityId");

        constructor(element: JQuery, opt: AfterGraduationPageWidgetRequest) {
            super(element, opt);

            var self = this;

            var cities = Q.getLookup<LMS.CitiesRow>("LMS.Cities");
            var data = cities.items.map(x => { return { id: x.Id, text: x.Name } });
            (self.cityId as any).select2({
                placeholder: "Şehir Seçiniz",
                allowClear: true,
                data: data,
                dropdownParent: self.modal,
            });
            (self.cityId as any).val(null).trigger("change");

            $(this.openModalId).click(function (e) {
                e.preventDefault();
                self.loadModal("");
            });

            //eğer modal kapatılırsa formu temizle
            self.modal.on("hidden.bs.modal", function () {
                //formClear();
                this.entityId = null;
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });

            this.bindEvents();
                            
            this.bindValidate();


            $(this.button).click((e)=> {
                e.preventDefault();

                if (!$(self.formSelector).valid()) return;

                var entity = <LMS.AfterGraduationUserAnswerRow>{};
                entity.LiveBroadcastId = self.options.ItemId;
                entity.Province = Q.toId($(self.formSelector).find("select[name='CityId']").val());
                entity.AfterGraduationTitle = Q.toId($(self.formSelector).find("input[name='Title']:checked").val());
                entity.Institution = Q.toId($(self.formSelector).find("input[name='Institution']:checked").val());
                entity.InstitutionOther = $(self.formSelector).find("input[name='InstitutionOther']").val();
                entity.HospitalName = $(self.formSelector).find("input[name='Hospital']").val();

                let onSuccess = (r : Serenity.SaveResponse) => {
                    SweetAlert.swal_success("Başarılı", "Canlı yayın katılımınız kaydedilmiştir.");
                    window.setTimeout(function () {
                        (self.modal as any).modal("hide");
                        window.setTimeout(function () {
                            window.location.reload();
                        }, 100);
                    }, 100);
                };

                let onError = (r) => {
                    SweetAlert.swal_alert("HATA", r.Error.Message);
                };
            
                LMS.AfterGraduationUserAnswerService.Create({
                    Entity : entity
                }, response => onSuccess(response),
                {
                    onError: response => onError(response)
                });
            });

            this.openDemoVideo();
        }

        openDemoVideo() {
            var self = this;
            $("#liveDemoVideoBtn").click(function (t) {
                t.preventDefault();
                var n = $(this).attr("data-video-path"),
                    vs = $(this).attr("data-video-source"),
                    ww = $(window).width() > 991 ? 480 : 264,
                    e = makeVideoPlayerHtml(n, vs, ww, "demoVideoPlayer"),
                    o = e.html,
                    r = e.options,
                    a = '<div id="liveDemoVideoModal" class="demo-video-modal">\n<h3 class="section-title after-line font-20 text-dark-blue">' + self.options.ItemName + '</h3>\n<div class="demo-video-card mt-25">\n';
                (a += o),
                    (a += "</div></div>"),
                    Swal.fire({
                        html: a,
                        showCancelButton: !1,
                        showConfirmButton: !1,
                        showCloseButton: !0,
                        customClass: { content: "p-0 text-left" },
                        width: "48rem",
                        didOpen: function () {
                            videojs("demoVideoPlayer", r);
                        },
                        didClose: function () {
                            videojs("demoVideoPlayer").dispose();
                        }
                    });
            });
        }

        bindEvents() {
            $("#InstitutionOther").hide();
            let insSelector = 'input[name="Institution"]';
            $(insSelector).change(function() {
                var selectedValue = $(insSelector + ':checked').val();
                if (selectedValue == "6") {
                    $("#InstitutionOther").show();
                } else {
                    $("#InstitutionOther").hide();
                }
            });
        }

        loadModal(title : string) {
            var self = this;
            let openModal = (title?: string) => {
                let m = (self.modal as any);
                m.modal({ keyboard: false, backdrop: 'static' });
                m.modal("show");
                m.find('.modal-title').text(title);
            }
            openModal();
        }

        private bindValidate() {
            var self = this;

            let r = {
                Title: {
                    required: true
                },
                CityId: {
                    required: true
                },
                Institution: {
                    required: true
                },
                InstitutionOther: {
                    required: function () {
                        return $("input[name='Institution']:checked").val() == "6";
                    }
                },
                Hospital: {
                    required: true
                },
                
            };
            let m = {
                Title: {
                    required: "* Ünvan seçiniz."
                },
                CityId: {
                    required: "* Şehir seçiniz."
                },
                Institution: {
                    required: "* Çalıştığı Kurum seçiniz."
                },
                InstitutionOther: {
                    required: "* Çalıştığı Kurum diğer seçeneği için açıklama giriniz."
                },
                Hospital: {
                    required: "* Hastane adı giriniz."
                }
            };

            //RT.recaptchaInclude(this.options.Recaptcha, $(self.button), r, m);

            $(this.formSelector).validate({
                errorClass: "is-invalid",
                rules: r,
                messages: m,
                errorPlacement: function(error, element) {
                    if (element.attr("type") === "radio") {
                        if (element.closest("#RadioTitle").length > 0)
                            error.insertBefore(element.closest("#RadioTitle"));
                        else if (element.closest("#RadioInstitution").length > 0)
                            error.insertBefore(element.closest("#RadioInstitution"));
                    } else {
                      error.insertAfter(element);
                    }
                }
            });
        }
    }
}